import { MeterBarChartThresholdProps } from '../types/meter-bar-chart.js';

export const findMatchingThreshold = (
  value: number,
  thresholdData: MeterBarChartThresholdProps[],
  min: number,
): MeterBarChartThresholdProps | undefined => {
  const filteredThresholdData = thresholdData.filter(
    (threshold) => value >= threshold.value,
  );

  if (!filteredThresholdData.length) {
    return undefined;
  }

  return filteredThresholdData.reduce(
    (final, current) => (current.value > final.value ? current : final),
    filteredThresholdData[0],
  );
};
